<template>
  <div class="flex item">
    <div class="box grow flex column justify-center p-10 info">
      <div class="flex item">
        <status-indicator
          v-if="product.quantity.onHand > 0 && isFromPrivateImport"
          class="ml-10"
          :negative="isNegative"
          :intermediary="isIntermediary"
          :positive="isPositive" pulse/>
        <InventoryProductTitle :product="product" />
        <span v-if="availableBatchNumber > 1" class="ml-5">
          <el-tooltip class="item" effect="dark" placement="top" :content="batchesTooltip">
            <el-tag size="mini">+{{availableBatchNumber-1}}</el-tag>
          </el-tooltip>
        </span>
      </div>
      <span class="fs-14 secondary-text" style="margin-left:5px;" v-if="shortDescription!=null">{{shortDescription}}</span>
      <span class="fs-14 secondary-text" style="margin-left:5px;" v-if="product.provider!=null">{{providerName}}</span>
      <Category class="fs-14 secondary-text" style="margin-left:5px;"  :category="product.category" :specificCategory="product.specificCategory" />
      <UnitFormatVolumeLabel class="ml-5" :unit="product.unit" :uvc="product.uvc" :format="product.format" :volume="product.volume"></UnitFormatVolumeLabel>
      <span class="mt-2"><el-tag size="mini" v-for="t in product.tags" :key="t.id">{{t.code}}</el-tag></span>
    </div>
    <div class="overdue align-vertical p-10">
      <span class="align-vertical-middle" v-if="product.quantity.inStock>0">{{product.quantity.inStock}}</span>
      <span class="align-vertical-middle" v-else>0</span>
      <span v-if="product.quantity.pending>0" class="align-vertical-middle ">
        <i class="el-icon-right "></i>{{product.quantity.pending-product.quantity.reservedDelayed}}
      </span>
    </div>
  </div>
</template>
<script>

import CustomerUtil from '@/utils/customer-util';
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel';
import Category from '@/components/product/category-txt';
import InventoryProductTitle from './inventory-product-title';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Inventory-product-tile',
  props: {
		isFromPrivateImport: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: null,
    },
    isPositive: {
      type: Boolean,
      default: false,
    },
    isIntermediary: {
      type: Boolean,
      default: false,
    },
    isNegative: {
      type: Boolean,
      default: false,
    }
	},
  data() {
    return {

    };
  },components: {
    UnitFormatVolumeLabel,
    InventoryProductTitle,
    Category,
  },
	methods: {

	},
	computed: {
    category () {
      let cat = null;

      if (_.get(this.product, 'category') != null) {
        cat = this.product.category.name;
      }

      if (_.get(this.product, 'specificCategory') != null) {
        if (cat != null) {
          cat += ' - ';
        }
        cat += this.product.specificCategory.name;
      }

      return cat;
    },
    shortDescription(){
      if (this.product.shortDescription == null || this.product.shortDescription === '') return null;
      return this.product.shortDescription;
    },
    providerName(){
      return CustomerUtil.customerName(_.get(this.product, 'provider.name'), _.get(this.product, 'provider.usualName'))
    },
    availableBatchNumber(){
      const batches = _.filter(this.product.items, i => i.quantity.onHand > 0);
      if (_.isEmpty(batches)) {
        return 0;
      }
      return batches.length;
    },
    batchesTooltip(){
      const batchesNumber = this.availableBatchNumber > 0 ? this.availableBatchNumber - 1 : 0;
      return this.$i18n.tc('products.additionnal_batches_information', batchesNumber,  { number: batchesNumber })
    },
	},
	watch : {

	},
	mounted(){

	},
	created(){

	}
}
</script>

<style lang="scss" scoped>

</style>
